import React from 'react';
import PropTypes from 'prop-types';
import A11ySvg from 'components/A11ySvg';
import './LuckIcon.css';

function LuckIcon({ className, size = 'base', title, alt, filled, disabled }) {
  const setClassName = `luck-icon ${className || ''}${size} ${
    filled ? ' filled' : ''
  }${disabled ? ' disabled' : ''}`;
  return (
    <A11ySvg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 17 19"
      className={setClassName}
      title={title}
      alt={alt}
    >
      <path
        className="inside-luck"
        d="M9.42828 2.07995C9.01908 1.54535 8.64353 1.15255 8.29526 0.893912C7.89761 0.598596 7.45781 0.423191 7.01596 0.532272C6.57244 0.641768 6.3014 0.994482 6.13946 1.34241C5.9745 1.69684 5.87842 2.13523 5.82573 2.59022C5.71975 3.50551 5.77586 4.61395 5.92297 5.56974C5.95154 5.75537 5.98381 5.93704 6.01947 6.11207C5.4921 5.69432 4.8763 5.23004 4.28417 4.85383C3.85546 4.58145 3.41574 4.33994 3.01621 4.19964C2.65264 4.07197 2.15917 3.96889 1.75531 4.22088C1.30837 4.49974 1.22837 5.0328 1.27512 5.54056C1.32058 6.03434 1.49683 6.67879 1.81292 7.49765C1.59939 7.93731 1.40657 8.31718 1.23864 8.64714C1.22847 8.66712 1.21838 8.68695 1.20836 8.70662C1.03085 9.05532 0.878079 9.35543 0.763797 9.60464C0.647354 9.85857 0.547016 10.1087 0.513067 10.3336C0.475957 10.5794 0.508141 10.8935 0.781114 11.1182C0.995783 11.295 1.27941 11.3384 1.49986 11.356C1.74288 11.3754 2.0462 11.3699 2.39545 11.3569C2.55641 11.3509 2.73092 11.3431 2.92012 11.3348C3.37006 11.3148 3.90309 11.2912 4.53446 11.2786C4.02315 12.1533 3.67658 12.8765 3.48134 13.4621C3.35625 13.8372 3.28509 14.1796 3.28413 14.483C3.28316 14.7884 3.35411 15.0897 3.55158 15.3311C3.95355 15.8224 4.62822 15.7999 5.18111 15.6776C5.65923 15.572 6.21505 15.3565 6.81649 15.0642C7.06705 15.5469 7.36996 15.9293 7.72383 16.1581C7.9665 16.3149 8.24509 16.4062 8.54264 16.3863C8.84074 16.3664 9.1082 16.2382 9.3336 16.0429C9.76713 15.6671 10.0831 15.014 10.2942 14.1684C10.4306 13.6217 10.53 12.9672 10.5828 12.2019C11.2232 13.037 11.715 13.6453 12.0974 14.0537C12.3617 14.3361 12.6078 14.561 12.8415 14.6912C13.0872 14.8283 13.434 14.9151 13.7547 14.6902C14.0006 14.5176 14.1136 14.2272 14.1796 14.0202C14.254 13.7871 14.3144 13.4972 14.3755 13.1922C14.3854 13.1431 14.3953 13.093 14.4055 13.042C14.5187 12.4727 14.6541 11.7918 14.8958 11.0446C15.7218 10.2454 16.2469 9.50455 16.4285 8.8337C16.5255 8.47531 16.529 8.11871 16.4068 7.78821C16.2841 7.45658 16.0521 7.19819 15.7604 7.00771C15.1974 6.64009 14.3718 6.4966 13.4248 6.5085C12.8527 6.51569 12.2107 6.58007 11.5119 6.7021C11.895 6.24043 12.2303 5.7979 12.5049 5.38309C12.9881 4.65329 13.3373 3.9321 13.353 3.31028C13.3614 2.97872 13.2753 2.65 13.0418 2.38108C12.8141 2.11887 12.493 1.96756 12.134 1.89031C11.4927 1.75231 10.5931 1.82132 9.42828 2.07995Z"
        fill="#E6ECFF"
        stroke="#999BB1"
        strokeLinejoin="round"
      />
      <path
        className="inside-luck"
        d="M10.8591 13.5C11.9564 15 11.221 15.8178 10 18"
        stroke="#999BB1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="inside-luck"
        d="M8 8L9.36097 9.36097"
        stroke="#546177"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path
        className="inside-luck"
        d="M8 9.35938L9.36097 7.9984"
        stroke="#546177"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
    </A11ySvg>
  );
}

LuckIcon.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string.isRequired,
  filled: PropTypes.bool,
  disabled: PropTypes.bool
};

export default LuckIcon;
